var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChatActivityBreakdown from '@web/components/Apps/Chat/ChatActivityBreakdown';
import DriveActionsOverTime from '@web/components/Apps/Drive/DriveActionsOverTime';
import { GeminiAdoptionTrend } from '@web/components/Apps/Gemini/GeminiAdoptionTrend';
import GmailActionsOverTime from '@web/components/Apps/Gmail/GmailActionsOverTime';
import MeetingLoadParticipants from '@web/components/Apps/Meet/MeetingLoadParticipants';
import { CommunicationNetworkGraphWidget } from '@web/components/CommunicationNetworkGraph/CommunicationNetworkGraphWidget';
import { TimeSpentOnWorkActivitiesSection } from '@web/components/Dashboard/TimeSpentOnWorkActivities/TimeSpentOnWorkActivitiesSection';
import { ActivityHeatmap } from '@web/components/PerformanceReview/Employee/Sections/DailyTimeline/ActivityHeatmap';
import { ActivitySummary } from '@web/components/PerformanceReview/Employee/Sections/Overview/ActivitySummary';
export var OverviewSection = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-20 mt-5" }, { children: [_jsx(ActivitySummary, {}), _jsx(CommunicationNetworkGraphWidget, { hideSummaryCards: true }), _jsx(TimeSpentOnWorkActivitiesSection, { includeUserFilter: true, userId: userId, orgUnitId: orgUnitId }), _jsx(GeminiAdoptionTrend, {}), _jsx(MeetingLoadParticipants, {}), _jsx(GmailActionsOverTime, {}), _jsx(ChatActivityBreakdown, {}), _jsx(DriveActionsOverTime, {}), _jsx(ActivityHeatmap, { userId: userId, orgUnitId: orgUnitId })] })));
};
